import { render } from "./ValidationErrors.vue?vue&type=template&id=b0f65356"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ValidationErrors.vue"]])

export default __exports__